import React, { useContext } from 'react'
import Calendar from './calendar'
import { TicketsAppContext } from '../context/tickets-app-context'
import { DatePickerHeader } from '../components'

function DatePicker({
  isMobiDisplayed,
  setIsMobiDisplayed,
  priceTableInfo,
  setPriceTableInfo,
  hours,
  showModal,
  remainingTicketsLoading
}) {
  const {
    actions: { selectDay },
    selectedDate,
    minimumAvailability
  } = useContext(TicketsAppContext)

  return (
    <>
      <DatePickerHeader />

      <div
        role="region"
        aria-label="Select the date of your reservation"
      >
        <Calendar
          isMobiDisplayed={isMobiDisplayed}
          setIsMobiDisplayed={setIsMobiDisplayed}
          priceTableInfo={priceTableInfo}
          setPriceTableInfo={setPriceTableInfo}
          hours={hours}
          selectedDate={selectedDate}
          selectDay={selectDay}
          minimumAvailability={minimumAvailability}
          showModal={showModal}
          remainingTicketsLoading={remainingTicketsLoading}
        />
      </div>
    </>
  )
}

export default DatePicker
